module.exports = __webpack_public_path__ + "assets/img/newest.1bb128f9.svg";